module.exports = __webpack_public_path__ + "img/Lanternes_de_mariage.fd0af67.jpg";